export default __webpack_public_path__ + "proximanova-extrabold-webfont.woff2";